import { PlayerTransactionState } from '../models'

const initialState: PlayerTransactionState = {
  isLoading: false,
  pagination: {
    total: 0,
    pages: 0,
    page: 1,
    limit: 25,
  },
  transactions: [],
  filters: {
    page: 1,
    limit: 25,
  },
  filterOptions: null,
}

export default initialState
